import React from "react";
import Skeleton from "react-loading-skeleton";
import { useLanguage } from "@/shared/components/shared/LanguageContext";
import TableSkeleton from "@/shared/components/shared/TableSkeleton";

const IpWhitelistTableSkeleton = ({ rows = 5 }) => {
  const { t } = useLanguage();

  const columns = [
    {
      header: t("merchants"),
      renderSkeleton: () => (
        <div className="flex flex-col">
          <Skeleton width={120} height={16} />
          <Skeleton width={100} height={12} className="mt-1" />
        </div>
      ),
    },
    { header: t("email"), width: 150 },
    { header: t("ipWhitelist"), width: 100, height: 24, borderRadius: "9999px" },
    { header: t("total") || "Total", width: 30, className: "text-right" },
    { header: t("actions") || "Actions", width: 32, height: 32, className: "text-right" },
  ];

  return <TableSkeleton columns={columns} rows={rows} />;
};

export default IpWhitelistTableSkeleton;
